import React from 'react'
import { driftSummary } from './blockChangeHelpers'

export default function BlocksDriftBanner({ checksum }) {
  const summary = driftSummary(checksum)
  if (!summary) return null

  return (
    <div
      className="notification is-warning is-light py-2"
      data-testid="blocks-drift-banner"
    >
      <p>{summary.message}</p>
      {summary.changes.map((change) => (
        <p key={change} className="is-size-7">
          {change}
        </p>
      ))}
    </div>
  )
}
